import React from 'react';
import { PRODUCTS } from '../../product';
import Product from "./product";
import "./shop.css"
import ProductDetail from '../detail/product-detail';
import {Hero} from "../../assets/index";


function Shop() {
  const handleClick = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  };
return (
<div className='shop'>
  <div className="hero">
    <img
      src={Hero} />
    <div className="content">
      <h3>Sending Love, One Bouquet at a Time.</h3>
      <p>A bouquet for every occasion.</p>
      <button className="btn" onClick={handleClick}>
        <div className="wrapper">
          <p className="text">Shop Now </p>

          <div className="flower flower1">
            <div className="petal one"></div>
            <div className="petal two"></div>
            <div className="petal three"></div>
            <div className="petal four"></div>
          </div>
          <div className="flower flower2">
            <div className="petal one"></div>
            <div className="petal two"></div>
            <div className="petal three"></div>
            <div className="petal four"></div>
          </div>
          <div className="flower flower3">
            <div className="petal one"></div>
            <div className="petal two"></div>
            <div className="petal three"></div>
            <div className="petal four"></div>
          </div>
          <div className="flower flower4">
            <div className="petal one"></div>
            <div className="petal two"></div>
            <div className="petal three"></div>
            <div className="petal four"></div>
          </div>
          <div className="flower flower5">
            <div className="petal one"></div>
            <div className="petal two"></div>
            <div className="petal three"></div>
            <div className="petal four"></div>
          </div>
          <div className="flower flower6">
            <div className="petal one"></div>
            <div className="petal two"></div>
            <div className="petal three"></div>
            <div className="petal four"></div>
          </div>
        </div>
      </button>
    </div>
  </div>
  <div >
  <div className='products'>
    {PRODUCTS.map((product)=> (
    <Product data={product} />
    ))}
  </div>
  </div>
</div>
)
}

export default Shop